export const actualId = (state) => state.actual;
export const actualBilling = (state) => (state.billings);
export const saving = (state) => state.saving;
export const loading = (state) => state.loading;
export const loadingData = (state) => state.loadingData;
export const list = (state) => state.list;
export const pagination = (state) => state.pagination;
export const actualFilter = (state) => state.actualFilter;
export const binnacle = (state) => state.binnacle;
